import { type TagSemanticoDTO } from '@framework/api-client/api/users/schemas/tagSemanticoDTO.ts';
import { type IFrontOfficeModule } from '@framework/common-web/frontoffice/module/IFrontOfficeModule.ts';
import { useMemo } from 'react';

/**
 * Aggrega i tag semantici dichiarati dalle sezioni del modulo in un'unica
 * lista piatta, da passare al validation context per alimentare il merge live
 * dei campi semantici.
 */
export function useModuleSemanticTags(
  module: IFrontOfficeModule | null | undefined,
): TagSemanticoDTO[] {
  return useMemo(
    () => module?.sezioni?.flatMap(s => s.sezione?.tagSemantici ?? []) ?? [],
    [module?.sezioni],
  );
}
